import { render, staticRenderFns } from "./ClientB2c2bCard.vue?vue&type=template&id=591664e4"
import script from "./ClientB2c2bCard.vue?vue&type=script&lang=js"
export * from "./ClientB2c2bCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports